module.exports = __webpack_public_path__ + "static/media/creating-your-adset-3.74444495.png";